import { Euro, ShoppingBag, Receipt, TrendingDown } from "lucide-react";
import { MetricCard, fmt } from "./KarolMetricsCards";

const CMV_SIGNAL_STYLES = {
  unknown:  { label: "Sem dados",  color: "text-gray-500  bg-gray-100"   },
  healthy:  { label: "Saudável",   color: "text-emerald-700 bg-emerald-50" },
  warning:  { label: "Atenção",    color: "text-amber-700 bg-amber-50"   },
  critical: { label: "Crítico",    color: "text-red-700   bg-red-50"     },
};

export function KarolFinanceSection({ financeSnapshot }) {
  if (!financeSnapshot || financeSnapshot.error) return null;

  const signal     = financeSnapshot.estimated_cmv_signal ?? "unknown";
  const cmv        = CMV_SIGNAL_STYLES[signal] ?? CMV_SIGNAL_STYLES.unknown;
  const billsCount = financeSnapshot.purchase_bills_count_30d ?? 0;
  const billsTotal = financeSnapshot.declared_purchase_total_30d ?? 0;

  return (
    <div className="space-y-3" data-testid="finance-section">
      <div className="flex items-center gap-2 px-1">
        <div className="h-px flex-1 bg-gray-100" />
        <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-widest">
          Finanças
        </span>
        <div className="h-px flex-1 bg-gray-100" />
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        <MetricCard
          icon={Euro}
          label="Receita hoje"
          value={fmt(financeSnapshot.revenue_today ?? 0)}
          accent
        />
        <MetricCard
          icon={ShoppingBag}
          label="Pedidos pagos"
          value={financeSnapshot.paid_orders_today ?? 0}
        />
        <MetricCard
          icon={Receipt}
          label="Ticket médio"
          value={fmt(financeSnapshot.avg_ticket_today ?? 0)}
        />
      </div>

      <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-4">
        <p className="text-[10px] font-semibold text-gray-400 uppercase tracking-wide mb-3">
          Compras (30 dias)
        </p>
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 bg-gray-50 rounded-lg flex items-center justify-center flex-shrink-0">
              <Receipt className="w-4 h-4 text-gray-400" />
            </div>
            <div>
              <p className="text-xs text-gray-400">
                {billsCount} {billsCount === 1 ? "fatura" : "faturas"}
              </p>
              <p className="text-sm font-semibold text-gray-800">
                {fmt(billsTotal)}
              </p>
            </div>
          </div>
          <div className={`flex items-center gap-1.5 px-2.5 py-1 rounded-full ${cmv.color}`}>
            <TrendingDown className="w-3 h-3" />
            <span className="text-[11px] font-semibold">CMV {cmv.label}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
